import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { singleton } from "logic/singleton";
import pseudoLocalize, { PSEUDO_LANGUAGE } from "util/pseudoLocalize";
const DEFAULT_LANGUAGE = "en";
const i18n = singleton("i18n", () => {
  const instance = i18next.createInstance();
  instance.use(initReactI18next).use({
    type: "postProcessor",
    name: "pseudo",
    process: (value, _key, _options, translator) => translator.language === PSEUDO_LANGUAGE ? pseudoLocalize(value) : value
  }).init({
    resources: {},
    postProcess: ["pseudo"],
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: { escapeValue: false }
  });
  instance.services.formatter.add("lowercase", (value) => value.toLowerCase());
  instance.services.formatter.add("capitalize", (value) => value.charAt(0).toUpperCase() + value.slice(1));
  return instance;
});
const loadersByLanguage = singleton("i18n.loaders", () => /* @__PURE__ */ new Map());
const loadTranslations = async (language, namespace, loader) => {
  if (i18n.hasResourceBundle(language, namespace)) {
    return;
  }
  const { default: translations } = await loader();
  i18n.addResourceBundle(language, namespace, translations);
};
export const registerTranslations = (namespace, english, otherLanguages) => {
  i18n.addResourceBundle(DEFAULT_LANGUAGE, namespace, english);
  Object.entries(otherLanguages).forEach(([language, loader]) => {
    if (!loadersByLanguage.has(language)) {
      loadersByLanguage.set(language, /* @__PURE__ */ new Map());
    }
    loadersByLanguage.get(language).set(namespace, loader);
  });
  const currentLanguageLoader = otherLanguages[i18n.language];
  return currentLanguageLoader ? loadTranslations(i18n.language, namespace, currentLanguageLoader) : Promise.resolve();
};
export const changeLanguage = async (language) => {
  var _a;
  const loaders = [...(_a = loadersByLanguage.get(language)) != null ? _a : /* @__PURE__ */ new Map()];
  const results = await Promise.allSettled(
    loaders.map(([namespace, loader]) => loadTranslations(language, namespace, loader))
  );
  results.forEach((result, index) => {
    if (result.status === "rejected") {
      console.error(`Could not load the "${language}" translations of "${loaders[index][0]}":`, result.reason);
    }
  });
  return i18n.changeLanguage(language);
};
export default i18n;
